import { FC, useEffect, useRef, useState } from 'react';
import { clsx } from 'clsx';

import { HeaderGroupExamsRowTableSchedule } from '../../rowTableSchedule';
import { makeRows } from '../lib/utils/makeRows';
import { ITableScheduleProps } from '../models/types';

import styles from './styles.module.scss';

export const TableSchedule: FC<ITableScheduleProps> = ({ dataSchedule }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const sentinelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!sentinelRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsScrolled(!entry.isIntersecting);
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0,
      },
    );

    observer.observe(sentinelRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div className={styles['table-schedule-container']}>
      <div ref={sentinelRef} className={styles['scroll-sentinel']} />
      <div className={styles['table-schedule']}>
        <div
          className={clsx(styles['table-schedule-header'], {
            [styles['table-schedule-header_scrolled']]: isScrolled,
          })}
        >
          <HeaderGroupExamsRowTableSchedule isScrolled={isScrolled} />
        </div>
        {makeRows(dataSchedule)}
      </div>
    </div>
  );
};
